import type * as React from "react";

import { cn } from "@/lib/utils";

/**
 * A single-line field, set on the recessed stock inside the emphasised
 * hairline. Mono because everything typed into this console is a code: a key
 * prefix, a uuid, an email, a Polar order id. Prose is never entered here.
 *
 * No `outline-none`: the base layer's `:focus-visible` rule is the focus
 * treatment, and overriding it here would be the one control on the page that
 * does its own thing.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-9 w-full min-w-0 rounded-[2px] border border-rule-strong bg-sunk px-2.5",
        "t-data text-[0.875rem] text-ink transition-colors",
        "placeholder:font-sans placeholder:text-ink-3",
        "hover:border-ink-3 focus-visible:border-ink focus-visible:-outline-offset-2",
        "aria-invalid:border-hold",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
